import {
  Box,
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import InputField from "../../../../common/components/FormFields/InputField";
import { useForm } from "react-hook-form";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";

export default function OperationTheaterTable(props) {
  const [openChild, setOpenChild] = React.useState(false);
  const [deleteGroup, setDeleteGroup] = React.useState("");

  const handleCloseChild = () => {
    if (openChild === true) {
      setOpenChild(false);
    }
  };
  const {
    control,
    handleSubmit,
    reset,
    register,
    setValue,
    getValues,
    watch,
    setError,
    clearErrors,
    trigger,
    setFocus,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
    // resolver: yupResolver(schema),
    // defaultValues,
  });

  const removeHeaders = (headers, fieldToRemove) => {
    return headers.filter((v) => {
      return !fieldToRemove.includes(v);
    });
  };

  const [chargesArray, setChargesArray] = React.useState([]);
  const [totalOtCharges, setTotalOtCharges] = React.useState([]);

  //function to get all the classes with rates in single array
  React.useEffect(() => {


    setChargesArray([]);
    if (props.otTableData.length > 0) {
      let dataArray = [...props.otTableData];
      let classData = [];
      for (let dataObject of dataArray) {
        for (let classObject of dataObject.selectedClasses) {
          classData.push(classObject);
          setChargesArray(classData);
        }
      }
    }
  }, [props.otTableData]);

  //function to get sum of the rates of the classes having same label
  const mergeArray = (arr) => {
    return arr.reduce((acc, val) => {
      const ind = acc.findIndex((item) => item.label === val.label);
      if (ind !== -1) {
        acc[ind]["totalCharge"] = acc[ind]["totalCharge"] + val["totalCharge"];
      } else {
        acc.push(val);
      }
      return acc;
    }, []);
  };

  //passing the classes array to the getSum function
  React.useEffect(() => {
    let charges = structuredClone(chargesArray);
    let calculatedArray = mergeArray(charges);
    setTotalOtCharges(calculatedArray);
    props.setParentCalculations([]);
  }, [chargesArray]);

  React.useEffect(() => {
    props.setOtTotal(totalOtCharges);
  }, [totalOtCharges]);

  const handleDeleteEstimation = (selectGroup) => {
    setOpenChild(true);
    setDeleteGroup(selectGroup);
  };

  const deleteRecord = () => {
    let afterDeleteArray = props.otTableData.filter(
      (item) => item.selectGroup.label !== deleteGroup.label,
    );
    props.setOtTableData(afterDeleteArray);
    handleCloseChild();
    setDeleteGroup("");
  };

  return (
    <div className="w-auto grid">
      <Box sx={{ width: "100%", overflow: "hidden" }}>
        <Paper sx={{ width: "100%", my: 1 }}>
          <div className="flex gap-2 items-center">
            <span className="font-semibold pl-3 py-1">Operation Theater</span>
          </div>
          <TableContainer
            sx={{
              "&::-webkit-scrollbar": {
                width: 7,
                height: 7,
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#7393B3",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "lightBlue",
              },
            }}
            className="rounded max-h-80"
            style={{
              borderLeft: "1px solid lightgray",
            }}
          >
            <Table size="small" stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell
                    className="whitespace-nowrap"
                    style={{ background: "#F1F1F1" }}
                  >
                    <span className="font-bold">Action</span>
                  </TableCell>
                  <TableCell
                    className="whitespace-nowrap"
                    style={{ background: "#F1F1F1" }}
                  >
                    <span className="font-bold">Group Name</span>
                  </TableCell>
                  <TableCell
                    className="whitespace-nowrap"
                    style={{ background: "#F1F1F1" }}
                  >
                    <span className="font-bold">Remark</span>
                  </TableCell>
                  {props.otTableData[0]?.selectedClasses?.map((item) => {
                    return (
                      <TableCell
                        className="whitespace-nowrap"
                        style={{ background: "#F1F1F1" }}
                        sx={{ textAlign: "center" }}
                      >
                        {props.selectedNameString
                          .toString()
                          .includes(item.label) ? (
                          <span className="font-bold">{item.label}</span>
                        ) : (
                          ""
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>

              <TableBody>
                {props.otTableData &&
                  props.otTableData.map((row, index) => {
                    return (
                      <TableRow
                        sx={{
                          "& td": {
                            paddingY: 0,
                          },
                        }}
                        tabIndex={-1}
                        key={index.id}
                        onClick={() => {
                          // handleClick(index, row);
                        }}
                      >
                        <TableCell>
                          <div
                            className="text-red-500 mr-3"
                            onClick={() => {
                              handleDeleteEstimation(row.selectGroup);
                            }}
                          >
                            {<DeleteOutlineOutlinedIcon />}
                          </div>
                        </TableCell>

                        <TableCell
                          className="whitespace-nowrap overflow-ellipsis capitalize "
                          sx={{ maxWidth: 5, overflow: "hidden" }}
                        >
                          {row.selectGroup?.label}
                        </TableCell>
                        <TableCell
                          className="whitespace-nowrap overflow-ellipsis capitalize "
                        // sx={{ maxWidth: 10, overflow: "hidden" }}
                        >
                          <fieldset onChange={() => { }}>
                            <input
                              className="pl-2 w-48 rounded border border-gray-400 my-1"
                              name={`remark${index + 1
                                }`}
                              label="Remark"
                              control={control}
                              type="text"
                              defaultValue={row?.remark || null}
                              // onChange={(e) => {
                              //   let dataArray = [...props.otTableData];
                              //   dataArray[index].remark = e.target.value || null;
                              //   props.setOtTableData(dataArray);
                              // }}
                              onBlur={(e) => {
                                let dataArray = [...props.otTableData];
                                dataArray[index].remark = e.target.value || null;
                                props.setOtTableData(dataArray);
                              }}
                            />
                          </fieldset>
                        </TableCell>

                        {row?.selectedClasses?.map((classObject, i) => {
                          return (
                            <TableCell
                              className="whitespace-nowrap capitalize"
                              sx={{ textAlign: "center" }}
                            >
                              {props.selectedNameString
                                .toString()
                                .includes(classObject.label) ? (
                                <fieldset onChange={() => { }}>
                                  <input
                                    className="text-center w-24 rounded border border-gray-400"
                                    name={`otCharges${classObject.label + index
                                      }`}
                                    label="Charges"
                                    control={control}
                                    defaultValue={classObject.totalCharge}
                                    type="number"
                                    min={0}
                                    onKeyDown={(e) => {
                                      if (e.key === "-" || e.key === "+") {
                                        e.target.blur();
                                      }
                                      if (e.key === "ArrowDown") {
                                        e.preventDefault();
                                      } else if (e.key === "ArrowUp") {
                                        e.preventDefault();
                                      }
                                    }}
                                    onWheel={(e) => {
                                      e.target.blur();
                                    }}
                                    onChange={(e) => {
                                      if (e.target.value !== "") {
                                        let dataArray = [...props.otTableData];
                                        dataArray[index].selectedClasses[
                                          i
                                        ].totalCharge = Number(e.target.value);
                                        props.setOtTableData(dataArray);
                                      } else {
                                        let dataArray = [...props.otTableData];
                                        dataArray[index].selectedClasses[
                                          i
                                        ].totalCharge = 0;
                                        props.setOtTableData(dataArray);
                                      }
                                    }}
                                  />
                                </fieldset>
                              ) : (
                                ""
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}

                <TableRow
                  sx={{
                    position: "sticky",
                    bottom: 0,
                    backgroundColor: "#fcf9e6",
                  }}
                >
                  <TableCell></TableCell>
                  {/* <TableCell></TableCell> */}
                  <TableCell>
                    <span className="font-semibold">Total :</span>
                  </TableCell>
                  {totalOtCharges.length > 0
                    ? totalOtCharges.map((item) => {
                      return (
                        <TableCell sx={{ textAlign: "center" }}>
                          {props.selectedNameString
                            .toString()
                            .includes(item.label) ? (
                            <span className="font-bold">
                              {item.totalCharge}
                            </span>
                          ) : (
                            ""
                          )}
                        </TableCell>
                      );
                    })
                    : ""}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
      <ConfirmationModal
        confirmationOpen={openChild}
        confirmationHandleClose={handleCloseChild}
        confirmationSubmitFunc={deleteRecord}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure want to delete this record ?"
        confirmationButtonMsg="Delete"
      />
    </div>
  );
}
